import styled from 'styled-components';
import { Button2 } from '../../../../../styles/buttons';

export const Card = styled.div`
  margin-top: 20px;
  padding: 16px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
  overflow-x: auto;

  @media (max-width: 576px) {
    padding: 12px;
  }
`;

export const CardTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 12px;
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;

  span:first-child {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.55);
  }

  span:last-child {
    font-size: 20px;
    font-weight: bold;
  }
`;

export const Warning = styled.div`
  color: #ad6800;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 6px;
  font-size: 13px;
`;

export const JobIdRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: wrap;
`;

export const JobIdValue = styled.code`
  font-size: 14px;
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-radius: 4px;
  word-break: break-all;
`;

export const CopyButton = styled.button`
  border: 1px solid #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${(props) => props.theme.colors.cyanDark};
    color: ${(props) => props.theme.colors.cyanDark};
  }
`;

interface StatusBadgeProps {
  variant: 'running' | 'success' | 'error';
}

const badgeColors: Record<StatusBadgeProps['variant'], string> = {
  running: '#1890ff',
  success: '#52c41a',
  error: '#f5222d',
};

export const StatusBadge = styled.span<StatusBadgeProps>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background-color: ${(props) => badgeColors[props.variant]};
`;

export const StatusDetail = styled.div`
  margin-top: 8px;
  font-size: 13px;
`;

export const ErrorMessage = styled.div`
  color: #f5222d;
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 4px;
  padding: 6px 10px;
  margin-top: 8px;
  font-size: 13px;
`;

export const StatusForm = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;

  input {
    width: 100%;
    height: 2rem;
    padding: 0 11px;
    font-size: 14px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;

    &:focus {
      border-color: ${(props) => props.theme.colors.cyanDark};
      outline-color: transparent;
      box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
    }
  }

  @media (max-width: 576px) {
    align-items: stretch;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 260px;
  min-width: 0;

  label {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 2px;
    color: rgba(0, 0, 0, 0.75);
  }
`;

export const ActionButton = styled(Button2)`
  border-radius: 20px;
  width: unset;
  flex: 0 0 auto;

  @media (max-width: 576px) {
    width: 100%;
  }
`;
